export default __webpack_public_path__ + "static/media/logo.7567c924.png";